// extracted by mini-css-extract-plugin
export default {"info":"_2Mp_J","time":"_16rGV","title":"_2nVyl","ellipsis":"Sc9i_","more":"Tfwh8"};